enum DesignInteractionEnum {
	getConfiguration = 'get_configuration',
	storeConfiguration = 'store_configuration'
}

export default DesignInteractionEnum;
